module.exports = __webpack_public_path__ + "img/banner.1f80cc20.png";